import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MiscService } from '../../_service/misc.service';
import { LeadsService } from 'src/app/_service/leads.service';
import { DoctorService } from 'src/app/_service/doctor.service';
import { AddEditZoneComponent } from '../add-edit-zone/add-edit-zone.component';
import { MatDialog } from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import * as XLSX from 'xlsx';
declare var $: any;

@Component({
  selector: 'app-master-zone-list',
  templateUrl: './master-zone-list.component.html',
  styleUrls: ['./master-zone-list.component.css']
})
export class MasterZoneListComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage: number = 25; zoneList: any = []; length: number = 0; pageEvent: PageEvent; loading: boolean = true; openmodal = '';
  pageSizeOptions = [10, 25, 50, 100]; pageIndex: number = 0; loaded: boolean = false; circles_copy = []; circles = []; circle = '';
  zone = ''; submitted: boolean = false; uploaded_msg: string = '';sc3Url:string='';
  @ViewChild('csvUpload', { static: false }) csvUpload: ElementRef;
  constructor(private dialog: MatDialog, public doctorapi: DoctorService, private sharedapi: SharedService, public miscapi: MiscService, public leadapi: LeadsService) { }

  ngOnInit(): void {
    this.sc3Url= localStorage.getItem('s3url');
    this.getcircle();
  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    }
  }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    }
  }

  ngAfterViewInit() {
    this.loadZoneList(0, this.perpage);
  }

  async loadZoneList(pageIndex, perpage) {
    this.zoneList = [];
    this.paginator.pageIndex = pageIndex;
    let qString = 'circle=' + this.circle + '&zone=' + this.zone;
    this.loading = true; this.loaded = false;
    await this.miscapi.getZoneList(this.paginator.pageIndex, perpage, qString).subscribe((data: any) => {
      this.length = parseInt(data.totaldata);
      this.loading = false;
      this.loaded = true;
      if (data.status) {
        this.zoneList = data.data;
      } else {
        this.zoneList = [];
      }
    }, error => {
      this.loading = false;
      this.loaded = true;
      this.sharedapi.checkError(error);
    });
  }

  pageChange(event) {
    this.pageIndex = event.pageIndex;
    this.loadZoneList(event.pageIndex, event.pageSize);
  }

  public getServerData(event: PageEvent): any {
    this.perpage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.loadZoneList(event.pageIndex, event.pageSize);
  }

  resetFilters() {
    this.circle = ''; this.zone = '';
    this.loadZoneList(0, 25);
  }

  openZoneDialog(zone) {
    const dialogRef = this.dialog.open(AddEditZoneComponent, {
      width: '50%',
      height: '50%',
      data: zone
    });
  }
  // ======csv============//
  hideModal() {
    this.uploaded_msg = '';
    $('#myModal').modal('hide');
  }

  showModal() {
    this.uploaded_msg = '';
    $('#myModal').modal();
  }

  async selectFile(event) {
    this.submitted = true;
    let file = event.target.files.item(0);
    const formData = new FormData();
    formData.append('file', file);
    this.uploaded_msg = "";
    this.miscapi.uploadZonecsv(formData).subscribe((data: any) => {
      this.submitted = false;
      this.csvUpload.nativeElement.value = "";
      if (data.status) {
        this.uploaded_msg = data.msg;
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  //=====Export List=====//
  exportZoneList() {
    if (this.zoneList.length > 0) {
      let data = [];
      let titles = ['Circle Name', 'Zone Name', 'Created Date'];

      data.push(titles);

      for (let key in this.zoneList) {
        let extData = [this.zoneList[key].circle_name, this.zoneList[key].zone_name, formatDate(this.zoneList[key].created_at * 1000, 'dd MMM, yyyy hh:mm aa', 'en-US')];
        data.push(extData)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      XLSX.writeFile(wb, 'zonelist_' + utc + '.xlsx');
    } else {
      this.sharedapi.presentToast('No Zone Data found!');
    }
  }


}
